module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page settings-page mx-5 relative",
    class: {
      onMobile: _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, [_c('li', {
    staticClass: "nav-li"
  }, [_c('label', {
    staticClass: "nav-label"
  }, [_vm._v("Account")])])])])], 2), _vm._v(" "), _c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.availableTabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), (_vm.currentUser !== null && _vm.currentUser.plan !== null) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.plansUpgradeModal),
      callback: function($$v) {
        _vm.plansUpgradeModal = $$v
      },
      expression: "plansUpgradeModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Plan Changes")]), _vm._v(" "), (_vm.plansName[_vm.currentUser.plan] == 'Listener') ? _c('v-card-text', [_vm._v("\n          Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to "), _c('b', [_vm._v(_vm._s(_vm.planChangeText) + ".\n          ")]), _vm._v("\n          You will remain listener until admin approve your account. Once you verified, you will be charged according to\n          subscription of current plan and new chosen plan.\n          Are you sure you want to continue?\n\n        ")]) : _c('v-card-text', [_vm._v("\n          Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to "), _c('b', [_vm._v(_vm._s(_vm.planChangeText) + ".\n          ")]), _vm._v("\n          This will have an immediate effect and you will be charged according to subscription of current plan and new\n          chosen plan.\n          Are you sure you want to continue?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "dark": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.subscriptionChange(_vm.planChangeText)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.hidePlanChangeModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('div', {
    staticClass: "page-content mt-130"
  }, [(_vm.active_tab == 'info') ? _c('div', {
    staticClass: "main-section"
  }, [_c('div', {
    staticClass: "content-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": "",
      "profile-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between mb-4"
  }, [_c('div', {
    staticClass: "avatar-section"
  }, [_c('h2', {
    staticClass: "mb-3 account-title"
  }, [_vm._v("Profile info")]), _vm._v(" "), _c('div', {
    staticClass: "__wrapper dflex align-center"
  }, [_c('div', {
    staticClass: "profile-image-section"
  }, [(_vm.profile.image) ? _c('div', {
    staticClass: "profile-image",
    style: ({
      'background-image': 'url(' + _vm.profile.image + ')',
    }),
    attrs: {
      "id": "profile_image"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.profile.image) ? _c('div', {
    staticClass: "profile-image-upload-section"
  }, [_c('input', {
    staticClass: "add-profile-image-file",
    attrs: {
      "type": "file",
      "name": "profile_image_file",
      "id": "profile_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.profileImageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "profile_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("Add\n                        ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.profile.image) ? _c('div', {
    staticClass: "profile-image-change-section"
  }, [_c('input', {
    staticClass: "change-profile-image-file",
    attrs: {
      "type": "file",
      "name": "profile_image_file",
      "id": "profile_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.profileImageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "profile_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("Update\n                        ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.profile.username))]), _vm._v(" "), _c('div', {
    staticClass: "display-name"
  }, [_vm._v(_vm._s(_vm.profile.display_name))]), _vm._v(" "), _c('label', {
    staticClass: "link--text profile_image_file",
    attrs: {
      "for": "profile_image_file"
    }
  }, [_vm._v("Change avatar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group user-names"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center _wrapper"
  }, [_c('div', {
    staticClass: "first-name"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.first_name),
      expression: "profile.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "last-name"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.last_name),
      expression: "profile.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "last_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  Email\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    class: {
      input: true,
      'text-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("email")) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v(" City ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  Country\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  Age group\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("SOCIAL MEDIA")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('v-menu', {
    staticClass: "social-type-menu",
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "nudge-top": -5,
      "nudge-left": 0,
      "content-class": "social-menu__content"
    }
  }, [_c('v-select', {
    staticClass: "social-types-selector py-0",
    class: {
      _filled: _vm.socialChannel
    },
    attrs: {
      "slot": "activator",
      "placeholder": _vm.socialChannel ? _vm.socialChannel.title : 'Select',
      "single-line": "",
      "hide-details": ""
    },
    slot: "activator"
  }), _vm._v(" "), _vm._l((_vm.socialChannels), function(channel, i) {
    return _c('div', {
      key: i,
      staticClass: "channel-info",
      class: [((channel.id) + "-menu")],
      on: {
        "click": function($event) {
          _vm.selectedChannel(channel)
        }
      }
    }, [_c('div', {
      staticClass: "_title"
    }, [_vm._v(_vm._s(channel.title))]), _vm._v(" "), _c('div', {
      staticClass: "_tags"
    }, [_vm._v("\n                        " + _vm._s(channel.tags) + "\n                      ")])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group mt-4"
  }, [_c('v-btn', {
    staticClass: "update-btn account-btn-save",
    nativeOn: {
      "click": function($event) {
        _vm.updateAccount()
      }
    }
  }, [_c('span', [_vm._v("Save")])])], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.subscriptionModal),
      callback: function($$v) {
        _vm.subscriptionModal = $$v
      },
      expression: "subscriptionModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n                Deactivate Subscription\n              ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                Are you sure you want to deactivate subscription?\n                This process might take a while. Please don't refresh page in this time.\n              ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deactivateSubscription()
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.disableSubscriptionModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)]) : (_vm.active_tab == 'password') ? _c('div', {
    staticClass: "main-section"
  }, [_c('div', {
    staticClass: "account-password"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": "",
      "password-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "account-password__title account-title"
  }, [_vm._v("\n                Reset your password\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  Current Password\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.current_password),
      expression: "password.current_password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      input: true,
      'text-danger': _vm.errors.has('password'),
    },
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password.current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "current_password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("password")) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  New Password\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new_password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.new_password),
      expression: "password.new_password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      input: true,
      'text-danger': _vm.errors.has('new_password'),
    },
    attrs: {
      "name": "new_password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "new_password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('new_password')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("new_password")) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  Confirm New Password\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('confirmed_password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.confirmed_password),
      expression: "password.confirmed_password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      input: true,
      'text-danger': _vm.errors.has('confirmed_password'),
    },
    attrs: {
      "name": "confirmed_password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password.confirmed_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "confirmed_password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('confirmed_password')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("confirmed_password")) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('v-btn', {
    staticClass: "update-btn account-btn-save",
    nativeOn: {
      "click": function($event) {
        _vm.updatePassword()
      }
    }
  }, [_vm._v("\n                Save\n              ")])], 1)], 1)], 1)]) : (_vm.active_tab == 'bank-details') ? _c('div', {
    staticClass: "main-section upload-page"
  }, [_c('div', {
    staticClass: "content-section"
  }, [(_vm.currentUser.creator_verified || _vm.currentUser.user_type == 'admin') ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "md6": "",
      "lg4": "",
      "bank-details-section": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "bank-details-section__title"
  }, [_vm._v("Connect payments")]), _vm._v(" "), (!_vm.currentUser.stripe_connected) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "stripe-status-identifier dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    staticClass: "stripe-img",
    attrs: {
      "src": require('@/assets/stripe_dark.svg'),
      "width": "100"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "status"
  }, [_vm._v("Connect Stripe account")])])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "href": _vm.stripeLink
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.stripeLink
    }
  }, [_c('v-icon', {
    staticClass: "cursor-pointer stripeLink-icon stripeLink-icon-add"
  }, [_vm._v("\n                      add\n                    ")])], 1)], 1)])]) : _c('div', [_c('div', {
    staticClass: "stripe-status-identifier stripe-status-identifier-connected dflex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    staticClass: "stripe-img",
    attrs: {
      "src": require('@/assets/stripe_dark.svg'),
      "width": "100"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "status-title"
  }, [_vm._v("Stripe")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v("Connected")])])]), _vm._v(" "), _c('div', [_c('v-icon', {
    staticClass: "cursor-pointer stripeLink-icon stripeLink-icon-remove",
    on: {
      "click": function($event) {
        _vm.openStripeDisconnectConfirmDialog()
      }
    }
  }, [_vm._v("\n                    remove\n                  ")])], 1)]), _vm._v(" "), (_vm.currentUser.stripe_connected) ? _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "href": _vm.currentUser.stripe_express_dashboard_link,
      "target": "_blank"
    }
  }, [_vm._v("\n                View Stripe Dashboard\n              ")]) : _vm._e()], 1)]) : _c('v-flex', {
    attrs: {
      "sm12": "",
      "md6": "",
      "lg4": "",
      "bank-details-section": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "bank-details-section__title"
  }, [_vm._v("You're not verified yet!")])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_stripe_disconnect_confirm_dialog),
      callback: function($$v) {
        _vm.show_stripe_disconnect_confirm_dialog = $$v
      },
      expression: "show_stripe_disconnect_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n              Do you really want to disconnect stripe?\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n              Your products will be deleted permanetly when you disconnect to\n              stripe.\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.disconnectAccount()
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStripeDisconnectConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1) : (_vm.active_tab == 'subscription') ? _c('account-subscription') : (_vm.active_tab == 'download') ? _c('account-download') : (_vm.active_tab == 'repost-price') ? _c('price-tab') : (_vm.active_tab == 'shipping-address') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('address-tab', {
    attrs: {
      "actionRight": "",
      "singleCol": "",
      "hideRequireIcon": "",
      "header": "Update your shipping address"
    }
  })], 1) : (_vm.active_tab == 'blocked') ? _c('div', {
    staticClass: "main-section"
  }, [_c('div', {
    staticClass: "content-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "bocked-user-section": "",
      "ma-0": ""
    }
  }, _vm._l((_vm.currentUser.blocked_users), function(blockedUser, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs12": "",
        "sm4": "",
        "form-group": ""
      }
    }, [_c('div', {
      staticClass: "blocked-users"
    }, [_c('user-tag', {
      attrs: {
        "user": blockedUser,
        "showAvatar": "",
        "clickUser": "",
        "showUserType": "",
        "width": "50",
        "height": "50"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "unblock-btn",
      attrs: {
        "outline": "",
        "round": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.unblockUser(blockedUser)
        }
      }
    }, [_vm._v("\n                  Unblock\n                ")])], 1)])
  }))], 1)]) : (_vm.active_tab == 'seller-policies') ? _c('policy-tab', {
    attrs: {
      "user": _vm.user,
      "updateUser": _vm.updateUser
    }
  }) : (_vm.active_tab == 'verify-status') ? _c('div', {
    staticClass: "main-section"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "verify-section": ""
    }
  }, [(_vm.currentUser.approver && _vm.currentUser.approver.display_name) ? _c('div', {
    staticClass: "verify-wrapper verified"
  }, [_c('div', {
    staticClass: "app-bold verify-status"
  }, [_vm._v("\n              " + _vm._s(this.requestStatuses[_vm.currentUser.request_status]) + "\n            ")]), _vm._v(" "), (_vm.currentUser.request_status !== 'pending') ? _c('div', {
    staticClass: "verified-by"
  }, [_vm._v("by " + _vm._s(_vm.currentUser.approver.display_name))]) : _c('div', [_c('span', [_vm._v("-")])])]) : _c('div', {
    staticClass: "verify-wrapper pending"
  }, [_c('div', {
    staticClass: "app-bold verify-status"
  }, [_vm._v("Pending")]), _vm._v(" "), _c('div', {
    staticClass: "verified-by"
  }, [_vm._v("-")])]), _vm._v(" "), ((_vm.currentUser.request_status === 'pending')) ? _c('div', [_c('span', [_vm._v(" You have already requested for account approval.")])]) : ((_vm.currentUser.request_status === 'denied')) ? _c('div', [_c('v-btn', {
    attrs: {
      "round": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.verifyReRequestStatus()
      }
    }
  }, [_vm._v("\n              Re request for verification\n            ")])], 1) : _vm._e()])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showGetVerifiedModal) ? _c('div', [_c('div', {
    staticClass: "verified-main"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('div', {
    staticClass: "text-center _title"
  }, [_vm._v("Get verified")]), _vm._v(" "), _c('div', {
    staticClass: "margin-vertical"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "_lable"
  }, [_vm._v("Social channel")]), _vm._v(" "), _c('v-menu', {
    staticClass: "social-type-menu",
    attrs: {
      "content-class": "s-menu__content"
    }
  }, [_c('v-select', {
    staticClass: "social-types-selector py-0",
    class: {
      '_filled': _vm.socialChannel
    },
    attrs: {
      "slot": "activator",
      "placeholder": _vm.socialChannel ? _vm.socialChannel.title : 'Choose',
      "single-line": "",
      "hide-details": ""
    },
    slot: "activator"
  }), _vm._v(" "), _vm._l((_vm.socialChannels), function(channel, i) {
    return _c('div', {
      key: i,
      staticClass: "channel-info",
      class: [((channel.id) + "-menu")],
      on: {
        "click": function($event) {
          _vm.selectedChannel(channel)
        }
      }
    }, [_c('div', {
      staticClass: "_title"
    }, [_vm._v(_vm._s(channel.title))]), _vm._v(" "), _c('div', {
      staticClass: "_tags"
    }, [_vm._v("\n                    " + _vm._s(channel.tags) + "\n                  ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "_lable"
  }, [_vm._v("Social Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialUsername),
      expression: "socialUsername"
    }],
    staticClass: "_socialHandle width100",
    attrs: {
      "placeholder": "Username",
      "type": "text"
    },
    domProps: {
      "value": (_vm.socialUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.socialUsername = $event.target.value
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3 px-3",
    attrs: {
      "round": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.verifiedSocialAttributes()
      }
    }
  }, [_vm._v("Get Verified")]), _vm._v(" "), _c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/cross.svg"),
      "width": "11"
    }
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.remainingDaysModal) ? _c('div', [_c('UpgradeModal', {
    attrs: {
      "daysRemaining": 30 - _vm.remainingDays()
    },
    on: {
      "remainingDaysModal": function($event) {
        _vm.remainingDaysModal = $event
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_vm._v("\n            If we need to contact you we will send a direct message from "), _c('strong', [_vm._v("@yousoundapp")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-703f06d1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/index.vue
// module id = 1769
// module chunks = 180